import React from 'react';

import './partner-header-style.scss';

const PartnerAppHeader: React.FC = (): JSX.Element => {
    return (
        <nav className="partner-header">
            <div className="top">
                <img src="https://assets.bizcapital.com.br/logos/parceiros.png" />
            </div>
        </nav>
    );
};

export default PartnerAppHeader;
